import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";
import { AppTester } from "../../../../supporting";

export const useGalleryArtContexts = () => {
    const {
        REACT_APP_URL_DEZIIIGN_GALLERY_ART
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()

    const links = useMemo(() => ([
        {
            id: ContextCodes.galllleryArt,
            active: false,
            content: 'gallllery',
            linkTo: REACT_APP_URL_DEZIIIGN_GALLERY_ART + suffix,
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: true,
            menuTitleSuffix: 'art',
            action: () => {
                window.open(`${REACT_APP_URL_DEZIIIGN_GALLERY_ART}${suffix}`, '_self');
            },
        }
    ]), [REACT_APP_URL_DEZIIIGN_GALLERY_ART, history])

    return {
        links,
        modalSettings: {
            titleColor: '',
            title: 'art'
        }
    }
}import { ContextCodes } from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import { useHistory, useLocation } from "react-router-dom";
import { AuthXService } from "@brg/auth";
import { useMemo } from "react";
import { AppTester } from "../../../../supporting";

export const useGalleryArtContexts = () => {
    const {
        REACT_APP_URL_DEZIIIGN_GALLERY_ART
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const history = useHistory()

    const links = useMemo(() => ([
        {
            id: ContextCodes.galllleryArt,
            active: false,
            content: 'gallllery',
            linkTo: REACT_APP_URL_DEZIIIGN_GALLERY_ART + suffix,
            target: '_self',
            level: 1,
            hasChildren: false,
            hasCornerArrow: true,
            menuTitleSuffix: 'art',
            action: () => {
                window.open(`${REACT_APP_URL_DEZIIIGN_GALLERY_ART}${suffix}`, '_self');
            },
        }
    ]), [REACT_APP_URL_DEZIIIGN_GALLERY_ART, history])

    return {
        links,
        modalSettings: {
            titleColor: '',
            title: 'art'
        }
    }
}